import { combineReducers } from "redux";

import categoryReducer from "./category";
import locationReducer from "./locations";
import assetReducer from "./asset";
import revaluateReducer from "./revaluate";
import disposalReducer from "./disposal";
import intangibleAssetsReducer from "./intangibleAssets";
import authReducer from "./Auth";
import usersReducer from "./user";
import rightOfUseReducer from "./rightOfUseAsset";
import newAsset from "./newAsset";
import active from "./activeAsset";
import exhausted from "./exhaustedAsset";
import locationData from "./locationData";
import yearData from "./yearData";
import colorChange from "./colorChange";
export default combineReducers({
  category: categoryReducer,
  location: locationReducer,
  assets: assetReducer,
  revalued: revaluateReducer,
  disposed: disposalReducer,
  intangible: intangibleAssetsReducer,
  auth: authReducer,
  users: usersReducer,
  rightOfUse: rightOfUseReducer,
  newAsset,
  active,
  exhausted,
  locationData,
  yearData,
  mode: colorChange,
});
